<script lang="ts">
  let {
    label = "Close",
    class: className = "btn-ghost",
  }: {
    label?: string;
    class?: string;
  } = $props();

  const onclick = (e: MouseEvent) => {
    (e.currentTarget as HTMLButtonElement).closest("dialog")?.close();
  };
</script>

<button {onclick} class="btn {className}" type="button">{label}</button>
